<template>
	<div>
		<div>
			<vx-card title="All SOWs" class="mb-5">
        <template slot="actions">
          <div class="flex items-center flex-wrap">
            <vs-button @click="BeginSOWReport" icon-pack="feather" icon="icon-file-text" size="small" class="mr-1 mb-1" :color="LerpColor(gradientStart, gradientEnd, 0)">Generate Report</vs-button>
            <vs-button :disabled="loading1 || syncingDevOps" @click="SyncDevOps()" icon-pack="feather" icon="icon-git-branch" size="small" class="mr-1 mb-1" :color="LerpColor(gradientStart, gradientEnd, 1/3)"> {{ (loading1 || syncingDevOps) ? 'Syncing...' : 'Sync DevOps' }}</vs-button>
            <vs-button :disabled="loading1" @click="Refresh()" icon-pack="feather" icon="icon-refresh-cw" size="small" class="mr-1 mb-1" :color="LerpColor(gradientStart, gradientEnd, 2/3)"> {{ (loading1) ? 'Loading...' : 'Refresh SOWs' }}</vs-button>
            <vs-button :disabled="loading1" @click="AddSOW()" icon-pack="feather" icon="icon-plus" size="small" class="mb-1" :color="LerpColor(gradientStart, gradientEnd, 1)">Add SOW</vs-button>
          </div>
        </template>
        <vs-table stripe max-items="50" no-data-text="No SOWs" pagination :data="sowListFullFiltered" v-model="selectedSOW" @selected="HandleSelectedSOW">
          <template slot="header">
            <div class="flex flex-wrap items-center" style="width: 100%;">
              <v-select
                placeholder="Client"
                class="sow-client-select mr-3"
                style="min-width: 200px; max-width: 280px;"
                v-model="sowClientFilter"
                :options="clientList"
                :reduce="x => x.ClientID"
                label="ClientName"
                clearable
              />
              <div style="flex: 1; min-width: 10px;"></div>
              <div class="flex items-center">
                <div v-if="search != ''" class="task-client theme-dark d-theme-light-bg mr-2">
                  Showing {{ sowListFullFiltered.length }} / {{ sowListFull.length }}
                </div>
                <div class="con-input-search vs-table--search"><input v-model="search" type="text" class="input-search vs-table--search-input"><i class="vs-icon notranslate icon-scale material-icons null">search</i></div>
              </div>
            </div>
          </template>
          <template slot="thead">
            <vs-th sort-key="SOWStatus">
              Status
            </vs-th>
            <vs-th sort-key="ClientName">
              Client Name
            </vs-th>
            <vs-th sort-key="SOWNumber">
              SOW #
            </vs-th>
            <vs-th sort-key="SOWName">
              Name
            </vs-th>
            <vs-th sort-key="DateRequestReceived">
              Date Received
            </vs-th>
            <vs-th sort-key="ManagedBy">
              Managed By
            </vs-th>
            <vs-th sort-key="SOWEstimate">
              Estimate
            </vs-th>
            <vs-th sort-key="DeveloperEstimate">
              Developer Estimate
            </vs-th>
            <vs-th sort-key="HoursLogged">
              Hours Logged
            </vs-th>
            <vs-th sort-key="PercentOfBudget">
              % Budget  
            </vs-th>
          </template>
          
          <template slot-scope="{data}">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <!-- Status -->
              <vs-td :data="tr.SOWStatus == null" class="relative">
                <div style="position: absolute; left: 15px; top: 50%; transform: translateY(-50%);">
                  <div v-if="OverageStatus(tr.OverageStatusID) == 'Needs Review'">
                    <vx-tooltip text="Overage Needs Review" position="right">
                      <feather-icon icon="AlertCircleIcon" svgClasses="w-5 h-5" class="text-warning" />
                    </vx-tooltip>
                  </div>
                  <div v-if="OverageStatus(tr.OverageStatusID) == 'Reviewed - Canceled'">
                    <vx-tooltip text="Overage Reviewed - Canceled" position="right">
                      <feather-icon icon="XCircleIcon" svgClasses="w-5 h-5" />
                    </vx-tooltip>
                  </div>
                  <div v-if="OverageStatus(tr.OverageStatusID) == 'Reviewed - On Hold'">
                    <vx-tooltip text="Overage Reviewed - Hold" position="right">
                      <feather-icon icon="PauseCircleIcon" svgClasses="w-5 h-5" />
                    </vx-tooltip>
                  </div>
                  <div v-if="OverageStatus(tr.OverageStatusID) == 'Reviewed - Approved'">
                    <vx-tooltip text="Overage Reviewed - Accepted" position="right">
                      <feather-icon icon="CheckCircleIcon" svgClasses="w-5 h-5" />
                    </vx-tooltip>
                  </div>
                  <div v-if="OverageStatus(tr.OverageStatusID) == 'On Track'">
                    <vx-tooltip text="On Track" position="right">
                      <feather-icon icon="CheckCircleIcon" svgClasses="w-5 h-5" />
                    </vx-tooltip>
                  </div>
                  <div v-if="tr.Alert == 1">
                    <vx-tooltip text="SOW Needs Work" position="right">
                      <feather-icon icon="AlertTriangleIcon" svgClasses="w-5 h-5 text-warning" />
                    </vx-tooltip>
                  </div>
                </div>
                <div class="pl-10">
                  <div :style="{background: tr.SOWStatusColorCode}" style="border-radius: 10px; padding: 5px; position: relative;">
                    <div style="background: #00000099; position: absolute; left: 0px; top: 0px; width: 100%; height:100%; border-radius: 10px;">
                    </div>
                    <div style="position: relative;">
                      {{ tr.SOWStatus }}
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td :data="tr.ClientName">
                {{ tr.ClientName }}
              </vs-td>
              <vs-td :data="tr.SOWNumber">
                {{ tr.SOWNumber }}
              </vs-td>
              <vs-td>
                <div v-if="tr.DescriptionURL != null && tr.DescriptionURL != ''" style="position: absolute; background: #ffffff33; color: white; height: 18px; padding: 4px; border-radius: 100%; margin-left: -22px; margin-top: 0px;"><feather-icon icon="LinkIcon" style="width: 10px; height: 10px;" /></div>
                {{ tr.SOWName }}
              </vs-td>
              <vs-td :data ="tr.DateRequestReceived">
                {{ DateFormatted(tr.DateRequestReceived) }}
              </vs-td>
              <vs-td>
                {{ tr.ManagedBy }}
              </vs-td>
              <vs-td>
                {{ tr.SOWEstimate }}
              </vs-td>
              <vs-td>
                {{ tr.DeveloperEstimate }}
              </vs-td>
              <vs-td :data="tr.HoursLogged">
                {{ tr.HoursLogged.toFixed(2) }}
              </vs-td>
              <vs-td>
                {{ tr.PercentOfBudget }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
			</vx-card>
		</div>

    <vs-prompt
      title="SOW Report"
      :active.sync="reportModal"
      :buttons-hidden="true"
    >
      <div>
        Report Date Range:
      </div>
      <div class="flex">
        <flat-pickr v-model="reportFromDate" placeholder="From Date" />
        <span class="ml-2 mt-2">-</span>
        <flat-pickr v-model="reportToDate" placeholder="To Date" class="ml-3"/> 
      </div>
      <div class="mt-4">
        <vs-button :disabled="generatingReport" @click="GenerateReport">Generate</vs-button>
      </div>
    </vs-prompt>

    <SOWModal ref="sowModal" @saved="OnSOWSaved" @deleted="OnSOWDeleted" />
	</div>
</template>

<script>

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import 'vue-select/dist/vue-select.css'
import SOWModal from '@/components/SOWModal.vue'
const moment = require('moment')

export default{
  components:{
    flatPickr,
    'v-select': vSelect,
    SOWModal
  },
  data() {
    return {
      selectedSOW: {},
      sowListFull: [],
      loading1: false,
      search: '',
      sowClientFilter: null,
      gradientStart: '#cc67f0',
      gradientEnd: '#7367f0',
      syncingDevOps: false,
      reportModal: false,
      reportFromDate: null,
      reportToDate: null,
      generatingReport: false
    }
  },
  computed: {
    sowListFullFiltered() {
      if (this.sowListFull.length == 0) {
        return []
      }
      let list = this.sowListFull
      if (this.sowClientFilter != null) {
        const cid = this.sowClientFilter
        list = list.filter(x => (x.ClientID != null && x.ClientID === cid) || (x.ITATInfo && x.ITATInfo.ClientID === cid))
      }
      if (this.search.trim() === '') {
        return list
      }
      if (list.length === 0) return []
      const keys = Object.keys(list[0])
      return list.filter(x => {
        for (let i = 0; i < keys.length; i += 1) {
          let value = x[keys[i]]
          if (value != null) {
            if (value.toString().toLowerCase().indexOf(this.search.toLowerCase()) != -1) return true
          }
        }
        return false
      })
    },
    clientList() {
			return this.$store.getters.GetClientList
    },
    sowOverageStatusLookups() {
      return this.$store.getters.GetSOWOverageStatusLookups
    },
    userLoggedIn () {
      return this.$store.getters.GetUserLoggedIn
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    sowList() {
      return this.$store.getters.GetSOWList
    }
  },
  watch : {
    userLoggedIn (loggedIn) {
      if (loggedIn) {
        this.OnLoggedIn()
      }
    },
    sowList() {
      this.ProcessSOWList()
    },
    sowListFullFiltered() {
      this.ApplySOWQueryParam()
    }
  },
  methods: {
    HexToRGB(h) {
      let r = 0, g = 0, b = 0
      if (h.length == 4) {
        r = '0x' + h[1] + h[1]
        g = '0x' + h[2] + h[2]
        b = '0x' + h[3] + h[3]
      } else if (h.length == 7) {
        r = '0x' + h[1] + h[2]
        g = '0x' + h[3] + h[4]
        b = '0x' + h[5] + h[6]
      }
      return { r: parseInt(r, 16), g: parseInt(g, 16), b: parseInt(b, 16) }
    },
    RGBToHex(r, g, b) {
      r = Math.round(r).toString(16).split('.')[0]
      g = Math.round(g).toString(16).split('.')[0]
      b = Math.round(b).toString(16).split('.')[0]
      if (r.length == 1) r = '0' + r
      if (g.length == 1) g = '0' + g
      if (b.length == 1) b = '0' + b
      return '#' + r + g + b
    },
    Lerp(a, b, t) {
      return a * (1 - t) + b * t
    },
    LerpColor(a, b, amount) {
      const rgb1 = this.HexToRGB(a)
      const rgb2 = this.HexToRGB(b)
      rgb1.r = this.Lerp(rgb1.r, rgb2.r, amount)
      rgb1.g = this.Lerp(rgb1.g, rgb2.g, amount)
      rgb1.b = this.Lerp(rgb1.b, rgb2.b, amount)
      return this.RGBToHex(rgb1.r, rgb1.g, rgb1.b)
    },
    BeginSOWReport() {
      this.reportModal = true
      this.reportFromDate = moment().startOf('year').format('YYYY-MM-DD')
      this.reportToDate = moment().format('YYYY-MM-DD')
    },
    async GenerateReport() {
      this.generatingReport = true
      await this.$store.dispatch('ActionGenerateSOWListReport', { reportType: 'chrome-pdf', from: this.reportFromDate, to: this.reportToDate })
      this.generatingReport = false
    },
    OverageStatus(statusId) {
      const statusLookup = this.sowOverageStatusLookups.find(x => x.LookupID == statusId)
      if(this.sowOverageStatusLookups == null || statusLookup == null) return 'Unknown'
      return statusLookup.LookupValue
    },
    AddSOW(){
      this.selectedSOW = {}
      this.$refs.sowModal.OpenForCreate()
    },
    OnSOWSaved() {
      this.FetchSOWs()
    },
    OnSOWDeleted() {
      this.FetchSOWs()
    },
    FetchSOWs() {
      this.loading1 = true
      this.$store.dispatch('ActionFetchSOWs').finally(() => {
        this.loading1 = false
      })
    },
    Refresh() {
      this.FetchSOWs()
    },
    async SyncDevOps() {
      this.syncingDevOps = true
      try {
        await this.$store.dispatch('ActionSyncDevOps')
        await this.FetchDevOpsReleases()
      } catch (e) {
        console.error(e)
      }
      this.syncingDevOps = false
    },
    ProcessSOWList() {
      this.sowListFull = this.sowList
    },
    OnLoggedIn () {
      this.FetchSOWs()
    },
    async FetchDevOpsReleases() {
      await this.$store.dispatch('ActionFetchDevOpsReleaseDefs')
    },
    ApplySOWQueryParam () {
      const sowNumber = this.$route.query.SOWNumber
      if (!sowNumber || this.sowListFullFiltered.length === 0) return
      const sow = this.sowListFullFiltered.find(x => String(x.SOWNumber) === String(sowNumber))
      if (sow) {
        this.selectedSOW = sow
        this.$refs.sowModal.OpenForSOW(sow)
        this.$router.replace({ path: this.$route.path, query: {} })
      }
    },
    HandleSelectedSOW () {
      this.$refs.sowModal.OpenForSOW(this.selectedSOW)
    },
    DateFormatted(date) {
      if (date == null) return ''
      return moment(date).format('MM/DD/YYYY')
    }
  },
  mounted () {
    if (this.userLoggedIn) {
      this.OnLoggedIn()
      this.ProcessSOWList()
      this.FetchDevOpsReleases()
    }
  }
}

</script>

<style lang="css">

.invoice-box {
  background: white;
  border-radius: 5px;
}

</style>
